import { getCharterBySlug } from './charterData';
import CharterDetailTemplate from './CharterDetailTemplate';

const ReefsPage = () => {
  const data = getCharterBySlug('reefs');
  if (!data) return null;
  return <CharterDetailTemplate destination={data} />;
};

export default ReefsPage;
